import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery, useMutation } from "react-query";

import { Container, Row, Col, Card, Form, Button, Modal, Spinner, Alert } from "react-bootstrap";
import { postUserAuth, postUserPasswordReset } from "../common/api";

import logo from '../assets/img/klett-baza-wiedzy-logo-lg.png';


const LoginComponent = () => {

  const navigate = useNavigate();
  const [loginSuccess, setLoginSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [passwordResetLoading, setPasswordResetLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [restoreEmail, setRestoreEmail] = useState("");
  const [passwordCorrect, setPasswordCorrect] = useState(false);
  const [resetPasswordMsg, setResetPasswordMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState(false);

  const [showRestorePasswordModal, setShowRestorePasswordModal] = useState(false);

  const handleRestorePasswordModalClose = () => {
    setShowRestorePasswordModal(false)
  }

  const postUserAuthQuery = useQuery(
    ['userData', {}], // Unikalny identyfikator zapytania
    () => postUserAuth(username, password), // Funkcja wykonująca zapytanie
    {
      enabled: false, // Wyłącz zapytanie na starcie
      retry: false,
      refetchOnWindowFocus: false
    }
  );

  const postUserPasswordResetMutation = useMutation(
    {
      mutationFn: () => postUserPasswordReset(restoreEmail),
      onSuccess: (data) => {
        setResetPasswordMsg('<small><span class="text-success">Na adres e-mail wysłaliśmy wiadomość zawierającą dalsze instrukcje.</span></small>');
        setPasswordResetLoading(false);
        setRestoreEmail("");
      },
      onError: (error) => {
        setResetPasswordMsg('<small><span class="text-danger">Wystąpił błąd, spróbuj ponownie później.</span></small>');
        setPasswordResetLoading(false)
      }
    }
  )  


  useEffect(() => {
    if(postUserAuthQuery.isError){
        return <div>Wystapił bład podczas ładowania treści</div>
    }
    if(postUserAuthQuery.isFetched === true && postUserAuthQuery.isSuccess === true && loading === true){
    
      if(postUserAuthQuery.data !== undefined && postUserAuthQuery.data.data !== undefined && postUserAuthQuery.data.data.data !== undefined && Object.keys(postUserAuthQuery.data.data.data).length > 0){
        let responseData = postUserAuthQuery.data.data.data;
        if(responseData.status === "success" && responseData.token.length > 0 && Object.keys(responseData.data).length > 0){

          localStorage.clear();
          localStorage.setItem("jwt", responseData.token);
          localStorage.setItem("permissions", JSON.stringify(responseData.data.permissions));
          localStorage.setItem("uid", responseData.data.uid);
          localStorage.setItem("profile", JSON.stringify(responseData.data.profile));
          localStorage.setItem("expires", responseData.data.expires);
          
          setLoginSuccess(true);
          setLoading(false);
          setUsername("");
          setPassword("");

          const url = new URL(window.location.href);
          let redirect = url.searchParams.get('redirect');

          const query = url.searchParams.get('query');
          if(query !== null){
            redirect = redirect + "&query=" + query; 
          }
          if(redirect === null){
            redirect = "/"
          }

          window.location.href = redirect;  
        }
        else{
          setLoading(false);
          setErrorMsg(true);
        }
      }
  
    }
    

  }, [postUserAuthQuery])


  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setErrorMsg(false);
    await postUserAuthQuery.refetch(); // Wykonaj zapytanie po kliknięciu przycisku "Zaloguj się"
  
  }

  const submitRestorePasswordForm = async (event) => {
    event.preventDefault();
    setPasswordResetLoading(true);
    postUserPasswordResetMutation.mutate({ email: restoreEmail });
  }

  const setRestoreEmailHandler = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setRestoreEmail(value)
    setResetPasswordMsg("");
    emailRegex.test(value) ? setPasswordCorrect(true) : setPasswordCorrect(false);
  }

  const alert = <Alert variant="danger">Podane przez Ciebie dane są niepoprawne.</Alert>

  return(
    <React.Fragment>
      <Container className="loginForm">

      <Row className="pt-5">
        <Col sm={12} md={6} lg={6}>

          <Row>
            <Col className="col-lg-8 col-10 offset-lg-2 offset-1">
              <div id="loginForm" className="border border-0 put-shadow card">
                <div className="cart-body">

                  <Row className="mb-4">
                    <Card.Title className="text-center h2 mb-4 text-uppercase">LOGOWANIE</Card.Title>
                    <Card.Title className="text-center">Nie masz konta?<br/><a href="https://klett.pl/rejestracja" target="_blank" title="Zarejestruj się" >Utwórz konto</a></Card.Title>
                  </Row>

                  <Form className="border border-end-0 border-start-0 py-4 my-4" onSubmit={handleSubmit}>
                    <Form.Group className="mb-4">
                      <Form.Label className="w-100 form-label">Email</Form.Label>
                      <Form.Control type="email" placeholder="Podaj adres e-mail" name="username" value={username} disabled={loading === true ? "disabled" : null} onChange={(e) => setUsername(e.target.value)} required />
                    </Form.Group>

                    <Form.Group className="mb-4">
                      <Form.Label className="w-100 form-label">Hasło</Form.Label>
                      <Form.Control type="password" placeholder="Podaj hasło" name="password" value={password} disabled={loading === true ? "disabled" : null} onChange={(e) => setPassword(e.target.value)} required />
                    </Form.Group>

                    {errorMsg ? alert : null}

                    <Button className="btn-primary w-100 mt-2" disabled={loading === true ? "disabled" : null} type="submit">{loading === true ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : "Zaloguj się"}</Button>
                  </Form>

                  <div className="text-center">
                    <button class="btn btn-light" onClick={(e) => setShowRestorePasswordModal(true)}>Nie pamiętasz hasła?</button>
                  </div>

                  <Modal show={showRestorePasswordModal} onHide={handleRestorePasswordModalClose}>
                    <Modal.Header closeButton>
                      <Modal.Title>Resetowanie hasła</Modal.Title>
                    </Modal.Header>
                    <Form onSubmit={(e) => submitRestorePasswordForm(e)}>
                    <Modal.Body>
                    Jeśli nie pamiętasz swojego hasła, możesz je zresetować poprzez wpisanie adresu e-mail poniżej. Pamiętaj, że musi to być adres którym, rejestrowałeś/-łaś się na stronie klett.pl.
                    
                    <Form.Group className="mb-4 mt-4">
                      <Form.Label className="w-100 form-label">Email</Form.Label>
                      <Form.Control type="email" placeholder="Podaj adres e-mail" name="email" value={restoreEmail} disabled={passwordResetLoading === true ? "disabled" : null} onChange={(e) => setRestoreEmailHandler(e.target.value)} required />
                    </Form.Group>

                    <div dangerouslySetInnerHTML={{__html: resetPasswordMsg}}></div>
                    
                    </Modal.Body>
                    <Modal.Footer>
                     <Button variant="primary" disabled={!passwordCorrect || passwordResetLoading} type="submit">{!passwordResetLoading ? "Resetuj hasło" : <Spinner size="sm" />}</Button>
                    <Button variant="secondary" type="button" onClick={handleRestorePasswordModalClose}>Anuluj proces</Button>
                      
                    </Modal.Footer>
                    </Form>
                  </Modal>

              </div>
            </div>
            </Col>
          </Row>

        
        </Col>
        <Col sm={12} md={6} lg={6} className="text-center">
          <img src={logo} alt="Baza wiedzy Klett Polska" className="img-fluid"/>
        
          <Row className="mt-4">
            <Col lg={{span: 10, offset: 1}}>
              <p className="mb-4 welcomeInfo">
              Baza wiedzy to stale rozwijany przez nas zbiór wartościowych materiałów dydaktycznych. To nie tylko pełna dokumentacja nauczyciela, ale również setki gotowych do wykorzystania na zajęciach scenariuszy, kart pracy, sprawdzianów, kartkówek, prezentacji, grafik, dyplomów i wiele innych ciekawych pomocy edukacyjnych.
              </p>
            </Col>
          </Row>
        </Col>
      </Row>


      
      </Container>

      

    </React.Fragment>
  )

}
export default LoginComponent;